// import { msntConsent } from '../msnt-consent';
import { config } from './froomle-default-config';

let loadingPromise;

const initFroomle = (params) => {
  if (loadingPromise) return loadingPromise;
  console.log('froomle initialized');

  if (!window.jsVars.froomle) return Promise.resolve();

  loadingPromise = Promise.all([
    import(/* webpackPrefetch: true */ '@msnt-shared/packages/froomle'),
  ])
    .then(([module]) => {
      module.setDefaults(config);

      const froomleApi = module.init(params);

      handleFroomleLoaded(froomleApi);

      return froomleApi;
    })
    // eslint-disable-next-line no-console
    .catch((err) => console.error(`[MSNT] Failed to load "Froomle" =>`, err));

  return loadingPromise;
};

const handleFroomleLoaded = async (froomleApiPromise) => {
  const froomleApi = await froomleApiPromise;

  if (!froomleApi) return;

  //to fix
  // msntConsent.addEventListener((state) => {
  //   froomleApi.setConsentState(state?.consents.analytics ?? false);
  // });
  froomleApi.setConsentState(true);
};

const getFroomleApi = () => {
  console.log('this is called');
  if (loadingPromise) return loadingPromise;

  return new Promise((resolve) => {
    window.addEventListener(
      'msnt-froomle-api-ready',
      () => {
        resolve(loadingPromise);
      },
      {
        once: true,
      },
    );
  });
};

export { initFroomle, getFroomleApi };
